import { createFileRoute } from '@tanstack/react-router'
import { SampleNoticeDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import { SampleNoticeDialog } from '@/routes/_app/-components/companies/sample-notice-dialog'

export const Route = createFileRoute('/@modal/welcome/samples')({
  staticData: { slotScope: '/_app' },
  pendingComponent: SampleNoticeDialogPending,
  component: SampleNoticeSlot,
})

function SampleNoticeSlot() {
  const slot = useModalSlot(Route)
  return <SampleNoticeDialog open={slot.open} onOpenChange={slot.onOpenChange} />
}
